import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../../utils/admin/apiRequest";
import InputField from "../../../ui/form/InputField";
import FileInputField from "../../../ui/form/FileInputField";
import Button from "../../../ui/utils/Button";
import usePost from "../../../../hooks/api/usePost";
import Alert from "../../../ui/utils/Alert";
import CheckboxField from "../../../ui/form/CheckboxField";
import SelectField from "../../../ui/form/SelectField";

const CreateMainCategory = ({ closeModal, callback }) => {
  const [preview, setPreview] = useState(null);
  const dropDownOptions = ["Optional", "Required", "Not Applicable"];
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.createMainCategory);



  const formik = useFormik({
    initialValues: {
      name: "",
      image: null,
      removeBg: false,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),

    }),
    onSubmit: async (values, { resetForm }) => {

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("start", values.start);
      formData.append("end", values.end);

      const response = await post({ data: { body: values } });
      if (response.response) {
        callback();
        resetForm();
        closeModal();
      }
    },
  });
  const categoryOptions = [
    { value: "ALL", label: "ALL" },
    { value: "BREAKFAST", label: "BREAK FAST" },
    { value: "LUNCH", label: "LUNCH" },
    { value: "SNACKS", label: "SNACKS" },
    { value: "DINNER", label: "DINNER" },
  ];

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Create Main Category </h2>
      <div className="border-b" />

      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
          <SelectField
            name="name"
            label="Category Name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched?.name && formik.errors.name}
            serverError={serverErrors?.name}
            options={categoryOptions}
          />

          <InputField
            name="start"
            type="time"
            label="Start Time"
            value={formik.values.start}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched?.start && formik.errors.start}
            serverError={serverErrors?.start}
          />

          <div className="col-span-full">

            <InputField
              name="end"
              type="time"
              label="End Time"
              value={formik.values.end}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.end && formik.errors.end}
              serverError={serverErrors?.end}
            />
          </div>

          {/* <div className="col-span-full">

            <FileInputField
              error={formik.touched.image && formik.errors.image}
              id="image"
              label="Image"
              accept="image/*"
              onChange={(e) => {
                const file = e.currentTarget.files?.[0] || null;
                formik.setFieldValue("image", file);
                setPreview(file ? URL.createObjectURL(file) : null);
              }}
            />

            {preview && (
              <img
                src={preview}
                alt="Preview"
                className="object-contain w-20 h-20 mt-2 border rounded"
              />
            )}
            <CheckboxField
              checked={formik.values.removeBg}
              name="removeBg"
              label=" Remove Background"
              id="removeBg"
              value={formik.values.removeBg}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              serverError={serverErrors?.removeBg}
              error={formik.touched.removeBg && formik.errors.removeBg}
            />
          </div> */}
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Creating..."
            isLoading={loading}
          >
            Create
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateMainCategory;
